var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-content"},[_c(_vm.current,{tag:"div",staticClass:"main"}),_c("OrderHistory",{tag:"div",staticClass:"main"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }